/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unused-state */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from "underscore";

// GRAPHQL
import * as cms from "../../shared/repos/cms/cms";
import cmsKeys from "../../shared/constants/cms";

// SUB UI
import * as frontApp from '../../shared/utilities/frontApp';

import styles from './Contact.module.css';
import ContactUsHeroSection from './ContactUsHeroSection';
import FaqSection from './FaqSection';
import ShareFeedback from './ShareFeedback';
import CustomerHelp from './CustomerHelp';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import refreshedQuestion from '../SecondaryPages/imgs/Question Icon.svg';
import refreshedSupport from '../SecondaryPages/imgs/Support Icon.svg';
import refreshedLightbulb from '../SecondaryPages/imgs/Feedback Icon.svg';



const lightbulbImage = require('./imgs/lightbulb.png');
const questionImage = require('./imgs/question-dark.png');
const supportImage = require('./imgs/support.png');

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      expandOptions: false,
      comment: '', // eslint-disable-line,
      errorMessage: null, 
      formType: 'Feedback',
      orderNumber: '',
      fullName: '',
      email: '',
      phone: '',
      phoneData: {},
      selectedTab: "frequently-asked-questions",
      subsectionId: ""
    }
    this.activeIndexCheck = null;
    this.scrollTargetRef = React.createRef();
  }

  componentDidMount() {
    const { match } = this.props;
    const {tabId} = match.params;
    const {subsectionId} = match.params;

    frontApp.initChat();
    cms.getContent([cmsKeys.checkoutPage.ringCentralSmsConsent], this);
    
    this.setState(
      {
        selectedTab: tabId ?? "frequently-asked-questions",
        subsectionId
      },
      () => {
        if (subsectionId) {
          setTimeout(() => {
            if (this.scrollTargetRef.current) {
              this.scrollTargetRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
            }
          }, 300);
        }
      }
    );
  }

  handleSectionUpdate = (option, index) => {
    const { history } = this.props;

    if (option.action) {
      return option.action(history);
    } 

    return this.setState({ 
      formType: option.name,
      activeIndex: index, 
      errorMessage: null, 
      expandOptions: false,
    }); 
  }

  getSMSConsent = () => {
    const { content } = this.state;
    return _.find(content, { key: cmsKeys.checkoutPage.ringCentralSmsConsent });
  };

  selectTab = (tab) => {
    this.setState({selectedTab: tab})
  }

  
  renderContactPage = () => {
    const { selectedTab, subsectionId } = this.state;
    const { contactUsSettings } = this.props;
    const refreshed = isBrandRefreshEnabled();
    const TabControl = refreshed ? 'button' : 'div';
    return (
      <div className={styles.pageWrapper} data-region="secondary-page" data-page="Contact">
        <div className={styles.pageContainer} data-part="contact-layout">

          <div className='w-full'>
            {refreshed ? <h1 data-part="secondary-page-title">Contact Us</h1> : <ContactUsHeroSection />}

            <div ref={this.scrollTargetRef} className="flex flex-col">
              <div data-part="contact-navigation" className="flex flex-col items-center justify-between border-b shadow-md bg-white dark:bg-dark">
                <div data-part="contact-tabs" className="relative flex flex-row items-center justify-between max-w-screen-desktop mx-auto w-full lg:w-auto h-[152px]">
                  <div
                    data-part="contact-tab-indicator"
                    className="absolute bottom-0 h-[4px] bg-dark transition-all duration-500 ease-in-out"
                    style={{
                      width: '33.3333%',
                      left:
                        // eslint-disable-next-line no-nested-ternary
                        selectedTab === 'frequently-asked-questions'
                          ? '0%'
                          : selectedTab === 'report-an-experience'
                          ? '33.3333%'
                          : '66.6666%',
                    }}
                  />

                  {/* Tabs */}
                  {[
                    { id: 'frequently-asked-questions', img: refreshed ? refreshedQuestion : questionImage, label: 'Frequently Asked Questions' },
                    { id: 'report-an-experience', img: refreshed ? refreshedSupport : supportImage, label: 'Report an Experience' },
                    { id: 'share-feedback', img: refreshed ? refreshedLightbulb : lightbulbImage, label: 'Share Feedback' },
                  ].map((tab) => (
                    <TabControl
                      key={tab.id}
                      type={refreshed ? 'button' : undefined}
                      data-part="contact-tab"
                      aria-pressed={refreshed ? selectedTab === tab.id : undefined}
                      aria-controls={refreshed ? 'contact-panel' : undefined}
                      aria-label={refreshed ? tab.label : undefined}
                      onClick={() => this.selectTab(tab.id)}
                      className="text-center w-[123px] md:w-[260px] h-[152px] md:h-[148px] flex flex-col gap-2 items-center justify-center text-sm leading-[16px] tracking-normal lg:text-lg lg:leading-[22px] lg:tracking-[-0.1px] text-dark cursor-pointer relative"
                    >
                      <img src={tab.img} alt="" className={`${selectedTab !== tab.id ? styles.inactiveTab : ''} w-[40px] h-[40px]`} />
                      <p className={` h-11 px-4 text-dark dark:text-light lg:text-lg text-sm  ${selectedTab !== tab.id ? `${styles.inactiveTab} font-medium font-montserratMedium` : 'font-bold font-montserratBold'}`}>
                        {refreshed && tab.id === 'frequently-asked-questions' ? (
                          <>
                            <span data-part="contact-label-desktop">{tab.label}</span>
                            <span data-part="contact-label-mobile">FAQ</span>
                          </>
                        ) : tab.label}
                      </p>
                    </TabControl>
                  ))}
                </div>             
              </div>

              <div id={refreshed ? 'contact-panel' : undefined} data-part="contact-content" className="flex flex-col items-center justify-between max-w-screen-desktop mx-auto px-4 mb-8">
                <div className='w-full py-8'>
                  {selectedTab === "frequently-asked-questions" && <FaqSection />}
                  {selectedTab === "report-an-experience" && (contactUsSettings.contact_us_feedback_enable === '1')
                    ? <CustomerHelp consentSmsContent={this.getSMSConsent()?.value || ""} sectionId={subsectionId} /> : null}
                  {selectedTab === "share-feedback" && <ShareFeedback />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return(
      <this.renderContactPage />
    )
  }
}

export const mapStateToProps = (state) => {
  const {
    contactUsSettings
  } = state.contactUsSetting;
  return {
    contactUsSettings
  };
};

export const mapDispatchToProps = () => ({
  
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Contact));
